<template>
  <div class="summary-mode-indicator-list-item" v-bind:class="{ 'overflow': this.isInOverflow }">
    <span>{{indicatorItem.resource.Name}}</span>
    <span>{{indicatorItem.data.Value}}</span>
    <span>{{indicatorItem.resource.Unit}}</span>
    <i class="material-icons">chevron_right</i>
  </div>
</template>

<script>
export default {
  name: 'SummaryModeIndicatorListItem',
  props: ['indicatorItem'],
  computed: {
    isInOverflow() {
      return (
        this.indicatorItem && this.indicatorItem.getOverflowLevel() !== 'ok'
      )
    }
  }
}
</script>

<style lang="less">
@import '../app.less';

.summary-mode-indicator-list-item {
  color: @dark-color;
  display: flex;
  align-items: center;
  cursor: pointer;

  &.overflow {
    color: white;
    background-color: @warning-color;

    &:hover {
      color: @dark-color;
      background-color: @warning-color;
    }
  }

  &:hover {
    color: white;
    background-color: @light-color;
  }

  > span {
    padding: 0 0.2rem;

    &:first-child {
      flex-grow: 1;
    }

    &:last-child {
      color: @light-color;
      font-weight: bold;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/SummaryModeIndicatorListItem.vue